<template>
    <div>
        <div class="form-group text-muted">
          <label>ID: </label>
          {{result.id}}
        </div>
        <text-input :value="result.name" label="Name" ref="name"/>
        <long-text-input :value="result.description" label="Kurzbeschreibung" ref="description"/>
        <text-input :value="result.link" label="Link" ref="link"/>
        <text-input :value="result.medium" label="Medium" ref="medium"/>
        <div class="form-group">
            <label>Publikationsdatum</label>
            <input v-model="result.dateOfPublication.date" ref="dateOfPublication" class="form-control">
        </div>
      <div class="form-group">
        <label>ISBN (falls vorhanden)</label>
        <input v-model="result.isbn" ref="isbn" class="form-control">
      </div>
      <div class="form-group">
        <label>Anzeigeposition</label>
        <input v-model="result.position" ref="position" class="form-control">
      </div>
        <div class="form-group">
            <label for="card-type">Art der Darstellung</label>
            <multiselect id="card-type" v-model="presentationType"
                        label="label"
                        :options="presentationTypeOptions"
                        :show-labels="false">
            </multiselect>
        </div>
        <file-input v-model="result.image" label="Bild" type="image"/>
        <file-input v-model="result.file" label="Datei" type="file"/>
        <div v-for="value, key in additionalProperties">
            <div v-if="value && value.class">
                <div v-if="value.class === 'TextPart'">
                    <text-input :value="value" :label="key" :ref="key"/>
                </div>
                <div v-if="value.class === 'LongTextPart'">
                    <long-text-input :value="value" :label="key" :ref="key"/>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label>Version</label>
            <multiselect :value="version"
                         @input="e => result.editVersion = e.id"
                         placeholder="Version" :options="options"
                         track-by="id" :allow-empty="false" label="name">
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </multiselect>
        </div>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
  props: ["data", "general"],
  components: { Multiselect },
  data() {
    return {
      versions: {
        1: "Bearbeiten",
        2: "Erster Entwurf",
        3: "Zweiter Entwurf",
        4: "Final",
        5: "Übersetzt",
        9: "Online"
      },
      presentationTypeOptions: [
        { label: 'Icon', value: 'icon' },
        { label: 'Bild', value: 'image' }
      ]
    };
  },
  computed: {
    presentationType: {
      get() {
        return this.presentationTypeOptions.find(option => option.value === this.result.presentationType);
      },
      set(option) {
        this.result.presentationType = option.value;
      }
    },
    result() {
      for (let result of this.data.results) {
        if (result.id == this.$route.params.resultId) {
          return result;
        }
      }
    },
    additionalProperties() {
      let r = {};
      for (let key in this.result) {
        if (
          ![
            "name",
            "description",
            "longDescription",
            "image",
            "file",
            "link",
            "medium"
          ].includes(key) &&
          this.result[key] &&
          this.result[key].class
        ) {
          r[key] = this.result[key];
        }
      }
      return r;
    },
    version() {
      return {
        id: this.result.editVersion,
        name: this.versions[this.result.editVersion]
      };
    },
    options() {
      return [
        { name: this.versions[1], id: 1 },
        { name: this.versions[2], id: 2 },
        { name: this.versions[3], id: 3 },
        { name: this.versions[4], id: 4 },
        { name: this.versions[5], id: 5 },
        { name: this.versions[9], id: 9 }
      ];
    }
  },
  methods: {
    save() {
      this.$refs.name.save();
      this.$refs.description.save();
      this.$refs.link.save();
      this.$refs.medium.save();
      for (let key in this.additionalProperties) {
        this.$refs[key][0].save();
      }
      let form = new FormData();
      if (this.result.image) {
        form.append("edit_result[image]", this.result.image.id);
      }
      if (this.result.file) {
        form.append("edit_result[file]", this.result.file.id);
      }
      form.append("edit_result[isbn]", this.result.isbn);
      form.append("edit_result[position]", this.result.position);
      form.append("edit_result[presentationType]", this.result.presentationType);
      form.append(
        "edit_result[dateOfPublication]",
        this.result.dateOfPublication.date
      );
      form.append("edit_result[editVersion]", this.version.id);

      axios.post(
        "/api/" + store.state.language + "/result/" + this.result.id + "/edit",
        form
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/result/Edit.vue